import { EventIconAndTime } from "@components/StatsConsole/Widgets/OverviewWidget/parts/EventIconAndTime";
import { MatchPlayerNameAndScore  } from "@components/StatsConsole/Widgets/OverviewWidget/parts/MatchPlayerNameAndScore";
import { formatEventTime } from "@utils/functions";
import { IMatchGoalPenaltyProps } from "@components/StatsConsole/Widgets/OverviewWidget/parts/interfaces";


const MatchEventPenaltyAway = ({ home_score, away_score, time, goalscorer, event_type, isPlusSignNeeded = false }: IMatchGoalPenaltyProps) => {
    const formattedTime = formatEventTime(time, isPlusSignNeeded);
    return (
        <div 
            data-testid="overview-goal-away"
            className='flex justify-end mx-[16px] mb-[8px] min-h-[34px] max-h-[34px]'>
            <MatchPlayerNameAndScore 
                ml="0px" 
                mr="8px" 
                startPosition='end' 
                event_type={event_type} 
                player={goalscorer} 
                homeScore={home_score}
                awayScore={away_score}
                isHomeGoal={false}
            />
            <EventIconAndTime iconName={event_type} time={formattedTime} />
        </div>
    )
}

export default MatchEventPenaltyAway;

